import { theme } from '@digibee/beehive-ui';

/**
|--------------------------------------------------
| Structure
|--------------------------------------------------
*/

export const Container = theme.styled('div', {
  width: 'fit-content',
  display: 'flex'
});
